import { render, staticRenderFns } from "./MediaList.vue?vue&type=template&id=5aa0823f&"
import script from "./MediaList.vue?vue&type=script&lang=ts&"
export * from "./MediaList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports